import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-links">
      <Link to="/support">Support</Link>
      <a href="mailto:support@pipelyze.com">Contact</a>
      <a href="/terms">Terms of Service</a>
      <a href="/privacy">Privacy Policy</a>
      <a href="/refunds">Refund Policy</a>
    </div>
    <div className="footer-copy">
      &copy; {new Date().getFullYear()} Pipelyze. All rights reserved.
    </div>
  </footer>
);

export default Footer;
